import { useCallback, useState } from 'react';

// Minimal promise-based confirm helper for replacing window.confirm
export function useConfirm() {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({
    title: 'Are you sure?',
    description: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    destructive: false,
  });

  const [resolver, setResolver] = useState(null);

  const confirm = useCallback((nextConfig) => {
    setConfig((prev) => ({ ...prev, ...(nextConfig || {}) }));
    setOpen(true);
    return new Promise((resolve) => {
      setResolver(() => resolve);
    });
  }, []);

  const onConfirm = useCallback(() => {
    setOpen(false);
    if (resolver) resolver(true);
    setResolver(null);
  }, [resolver]);

  const onCancel = useCallback(() => {
    setOpen(false);
    if (resolver) resolver(false);
    setResolver(null);
  }, [resolver]);

  return {
    confirm,
    dialogProps: {
      open,
      onOpenChange: (v) => {
        // treat closing as cancel
        if (!v) onCancel();
        else setOpen(v);
      },
      ...config,
      onConfirm,
      onCancel,
    },
  };
}
